import { StockItemAllocation } from './stock-item-allocation';

export interface StockItemAllocations {
  id: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  productType: string;
  allocations: StockItemAllocation[];
}
